import React, { useEffect, useState } from 'react';
import { Dropdown } from '@naf/dropdown';
import { sortByType } from '@appTypes/sortByType';
import { useFilterAction } from '@utils/bilguide';
import { getURLParams } from '@lib/getUrlParams';

interface DropdownValue {
  label: string;
  value: sortByType;
  optionNumber: number;
}

const dropdownContent: Record<sortByType, DropdownValue> = {
  [sortByType.APPROVAL_DATE_DESCENDING]: {
    label: 'Sist testet',
    value: sortByType.APPROVAL_DATE_DESCENDING,
    optionNumber: 1,
  },
  [sortByType.ALPHABETICALLY_DESCENDING]: {
    label: 'Alfabetisk',
    value: sortByType.ALPHABETICALLY_DESCENDING,
    optionNumber: 2,
  },
};

const options = Object.values(dropdownContent).sort((e1, e2) => e1.optionNumber - e2.optionNumber);

const CarSortDropdown = () => {
  const [selectedValue, setSelectedValue] = useState<DropdownValue>(
    dropdownContent[sortByType.APPROVAL_DATE_DESCENDING],
  );
  const { applySort } = useFilterAction();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const parsedParams = getURLParams();
      if (typeof parsedParams.sortBy !== 'undefined') {
        setSelectedValue(dropdownContent[parsedParams.sortBy as sortByType]);
      }
    }
  }, []);

  const handleSelect = (value: DropdownValue) => {
    applySort(value.value);
    setSelectedValue(value);
  };

  return (
    <Dropdown width="200px" options={options} justify="right" selected={selectedValue} handleSelect={handleSelect} />
  );
};

export default CarSortDropdown;
